const KEY = "criticalc_access";

export const getAccessToken = () => localStorage.getItem(KEY) || "";
export const setAccessToken = (t) => localStorage.setItem(KEY, t);
export const clearAccessToken = () => localStorage.removeItem(KEY);
export const lockApp = () => window.dispatchEvent(new Event("cc-locked"));
